
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.94 0h-.831l-1.166 5.932L32.778 0h-.833l1.598 7.792v2.332h.8V7.792L35.941 0zM24.033 0h-.799v10.124h3.375v-.676h-2.576V0zM1.28 0H0v.676h1.28v9.448h.798V.676h1.28V0H1.28zM7.368 6.75c.345 0 .625-.28.625-.625V.675h.001V0h-3.36v10.124h.8V6.75h.74l1.26 3.373h.832L7.006 6.75h.361zM5.433.677h1.761v5.158a.233.233 0 01-.232.233H5.433V.676zM21.943 0h-3.359v10.124h.798V6.75h1.948c.347 0 .628-.28.628-.626V.001h-.015V0zm-1.02 6.067h-1.54V.676h1.773v5.158a.233.233 0 01-.233.233zM11.855 0v9.44h-1.54a.233.233 0 01-.233-.232V0h-.803v9.498c0 .346.282.626.629.626h2.746V0h-.799zM14.734 9.208V4.736h2.038V4.06h-2.038V.682H17.2V.006h-2.465V0h-.802v9.498c0 .346.281.626.628.626h2.746V9.44h-2.338a.233.233 0 01-.234-.232zM29.945 0h-1.472a.614.614 0 00-.605.587l-.2 3.473h-1.514v.676h1.475l-.312 5.388h.773l.319-5.388h1.6l.318 5.388h.773L30.55.587A.614.614 0 0029.944 0zm-1.496 4.06l.187-3.162a.232.232 0 01.229-.222h.688c.121 0 .221.097.229.222l.187 3.162h-1.52z","fill":"#2569F6"}})])
          )
        }
      }
    